import React, { Component } from "react";
import { Spinner } from "react-bootstrap";

// font awesome
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class DownloadExcelReport1 extends Component {
  delayUpdate = null;

  onDownload = e => {
    const { onClearDownload, resetPlaceholder } = this.props;
    onClearDownload && onClearDownload();
    resetPlaceholder && resetPlaceholder();
  };

  render() {
    const {
      props: {
        excelStyle,
        isLoading,
        downloadLink,
        onStartDownloading,
        iconClassName = "download-icons-excel",
        border,
        onDownloadLinkClick,
        isDraft
      },
      onDownload
    } = this;

    let excelClassName;
    // if (isDraft) {
    //   excelClassName = `download-excel-component-draft1 `;
    // } else {
    //   excelClassName = ;
    // }
    return (
      // <div className="download-excel-component">
      <span
        className={`download-excel-component-agenda-select ${
          excelStyle ? "excel-component" : ""
        } ${border ? "download-excel-radius" : ""}`}
      >
        {isLoading ? (
          <span className="download-icon downloading">
            <span className={iconClassName} />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </span>
        ) : downloadLink ? (
          <span className="download-icon agenda-download-ppt-icon">
            <a
              className="download-img"
              download={"Abcde.xls"}
              href={downloadLink}
              target={iconClassName === "pdf-icon" ? "_blank" : ""}
              onClick={onDownload}
            >
              <FontAwesomeIcon icon={faDownload} size="2x" />
            </a>
          </span>
        ) : (
          <span
            onClick={onStartDownloading}
            //className="download-mis-file download-icon "
          >
            <span className={iconClassName} />
          </span>
        )}
      </span>

      // </div>
    );
  }
}
